import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Ensure favicon dynamically points to SOFTLINE LOGO 1_ImgID1.png
const faviconUrl = "/images/SOFTLINE%20LOGO%201_ImgID1.png";
const existingIcons = document.querySelectorAll("link[rel*='icon']");
existingIcons.forEach((el) => {
  el.type = "image/png";
  el.href = faviconUrl;
});
if (!existingIcons.length) {
  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/png";
  link.href = faviconUrl;
  document.head.appendChild(link);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
